import { AnyAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../app/store'
import { Page, pageOf, startPageOf } from '../../models/page'
import { fromJson, Tenant } from '../../models/tenant'
import * as ST from '../../services/tenant'
import {
  getLabelAddFnParams,
  getLabelListFnParams,
  getTenantLabelListFnParams,
  TenantQueryParams,
} from '../../services/tenant'
interface TenantState {
  page: Page<Tenant>
  replaceOpentype?: number //代煎是否开启
  replaceId?: number // 代煎id
}

const initialState: TenantState = {
  page: startPageOf(),
  replaceOpentype: 0,
}

export const getTenantList = createAsyncThunk<
  Page<Tenant>,
  TenantQueryParams,
  RootThunkApi<Page<Tenant>>
>('tenant/getTenantListAsyncStatus', async (params, api) => {
  return sendAsync(ST.getTenantList(params), api).then(
    (data: Record<string, never>) =>
      pageOf(
        data,
        _.chain(data.records)
          .map((t) => fromJson(t))
          .value()
      )
  )
})

export const getOrganizationList = createAsyncThunk<
  void,
  TenantQueryParams,
  RootThunkApi
>('tenant/getTenantListAsyncStatus', async (params, api) => {
  return sendAsync(ST.getTenantList(params), api)
})

// 批量重置接口
export const getVolumeGrantMenus = createAsyncThunk<
  void,
  ST.VolumeGrantMenusParams,
  RootThunkApi<void>
>('tenant/volumeGrantMenusAdd', async (params, api) => {
  return sendAsync(ST.volumeGrantMenus(params), api)
})


// 批量增值服务接口
export const getResectSettingLabel = createAsyncThunk<
  void,
  ST.ResetSettingParams,
  RootThunkApi<void>
>('tenant/getResectSettingLabel', async (params, api) => {
  return sendAsync(ST.resectSettingLabel(params), api)
})

// 批量机构模板详情
export const getTemplateDetail = createAsyncThunk<
  void,
  ST.TemplateDetailParams,
  RootThunkApi<void>
>('tenant/getTemplateDetail', async (params, api) => {
  return sendAsync(ST.templateDetail(params), api)
})
export const getTemplateDetailSecond = createAsyncThunk<
  void,
  ST.TemplateDetailParams,
  RootThunkApi<void>
>('tenant/templateDetailSecond', async (params, api) => {
  return sendAsync(ST.templateDetailSecond(params), api)
})


// 批量模板复制
export const getCopyBatchSubmit = createAsyncThunk<
  void,
  ST.CopyBatchParams,
  RootThunkApi<void>
>('tenant/getCopyBatchSubmit', async (params, api) => {
  return sendAsync(ST.copyBatchSubmit(params), api)
})

export const getCopyBatchSubmitSecond = createAsyncThunk<
  void,
  ST.CopyBatchParams,
  RootThunkApi<void>
>('tenant/getCopyBatchSubmitSecond', async (params, api) => {
  return sendAsync(ST.copyBatchSubmitSecond(params), api)
})

// 批量机构目录详情
export const getDirectoryReplicationDetail = createAsyncThunk<
  void,
  ST.DirectoryReplicationDetailParams,
  RootThunkApi<void>
>('tenant/getDirectoryReplicationDetail', async (params, api) => {
  return sendAsync(ST.directoryReplicationDetail(params), api)
})

export const getDirectoryReplicationDetailSecond = createAsyncThunk<
  void,
  ST.DirectoryReplicationDetailParams,
  RootThunkApi<void>
>('tenant/getDirectoryReplicationDetailSecond', async (params, api) => {
  return sendAsync(ST.directoryReplicationDetailSecond(params), api)
})

// 批量目录复制
export const getCopyDirectoryReplicationSubmit = createAsyncThunk<
  void,
  ST.CopyDirectoryReplicationParams,
  RootThunkApi<void>
>('tenant/getCopyDirectoryReplicationSubmit', async (params, api) => {
  return sendAsync(ST.copyDirectoryReplicationSubmit(params), api)
})

export const getCopyDirectoryReplicationSubmitSecond = createAsyncThunk<
  void,
  ST.CopyDirectoryReplicationParams,
  RootThunkApi<void>
>('tenant/getCopyDirectoryReplicationSubmitSecond', async (params, api) => {
  return sendAsync(ST.copyDirectoryReplicationSubmitSecond(params), api)
})

export const createOrUpdateTenant = createAsyncThunk<
  void,
  Tenant,
  RootThunkApi<void>
>('tenant/createOrUpdateTenantStatus', async (tenant, api) => {
  return sendAsync(ST.createOrUpdateTenant(tenant), api)
})


// 批量开通代煎设置
export const isBatchOpenReplaceMake = createAsyncThunk<
  void,
  ST.BatchOpenReplaceMakeParams,
  RootThunkApi<void>
>('tenant/isOpenReplaceMake', async (tenant, api) => {
  return sendAsync(ST.batchOpenReplaceMake(tenant), api)
})

// 开通代煎设置
export const isOpenReplaceMake = createAsyncThunk<
  void,
  ST.OpenReplaceMakeParams,
  RootThunkApi<void>
>('tenant/isOpenReplaceMake', async (tenant, api) => {
  return sendAsync(ST.openReplaceMake(tenant), api)
})

// 代煎设置回显
export const isSetReplaceMake = createAsyncThunk<
  void,
  number,
  RootThunkApi<void>
>('tenant/isSetReplaceMake', async (id, api) => {
  return sendAsync(ST.settingReplaceMake(id), api)
})

export const getTenantDetail = createAsyncThunk<
  Tenant,
  string,
  RootThunkApi<Tenant>
>('tenant/getTenantDetailStatus', async (tenantId, api) => {
  return sendAsync(ST.getTenantDetail(tenantId), api).then((data: unknown) =>
    fromJson(data)
  )
})

export const toggleTenantState = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>('tenant/toggleTenantStateStatus', async (tenantId, api) => {
  return sendAsync(ST.toggleTenantState(tenantId), api)
})

// 省市区
export const getProvinceList = createAsyncThunk<
  void,
  ST.AllParams,
  RootThunkApi
>('ProvinceList/list', async (params, api) => {
  return sendAsync(ST.getProvince(params), api)
})

// 查询所有的省市区
export const getAllList = createAsyncThunk<any, void, RootThunkApi>(
  'ProvinceList/list',
  async (_, api) => {
    return sendAsync(ST.getAll(), api)
  }
)

// 导出
export const getExportExcelAsync = createAsyncThunk<
  void,
  ST.ExportExcelParams,
  RootThunkApi
>('/commodity/exportExcel', async (body, api) => {
  return sendAsync(ST.getExportExcel(body), api)
})

// 导入
export const getImportExcelAsync = createAsyncThunk<
  void,
  ST.ImportExcelParams,
  RootThunkApi
>('/commodity/importExcel', async (body, api) => {
  return sendAsync(ST.getImportExcel(body), api)
})

// 订单导入
export const orderImportExcelAsync = createAsyncThunk<
  void,
  ST.ImportExcelParams,
  RootThunkApi
>('/commodity/orderImportExcelAsync', async (body, api) => {
  return sendAsync(ST.orderImportExcel(body), api)
})

const tenantSlice = createSlice({
  name: 'admin.tenant',
  initialState,
  reducers: {
    setReplaceOpentype: (state, action) => {
      state.replaceOpentype = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTenantList.fulfilled, (state, action) => {
      state.page = action.payload
    })
  },
})

// 订单管理列表
export const getOrderList = createAsyncThunk<
  void,
  ST.getOrderListFnParams,
  RootThunkApi
>('ProvinceList/getOrderList', async (params, api) => {
  return sendAsync(ST.getOrderListFn(params), api)
})

// 服务管理列表
export const getServerList = createAsyncThunk<
  void,
  ST.getOrderListFnParams,
  RootThunkApi
>('ProvinceList/getServerListFn', async (params, api) => {
  return sendAsync(ST.getServerListFn(params), api)
})


// 订单管理-产品价格列表
export const getOrderPriceList = createAsyncThunk<any, void, RootThunkApi>(
  'ProvinceList/getOrderPriceList',
  async (_, api) => {
    return sendAsync(ST.getOrderPriceListFn(), api)
  }
)

// 订单管理-导出
export const getOrderDetailExport = createAsyncThunk<
  void,
  ST.getOrderListFnParams,
  RootThunkApi
>('stand/getUseDetailExport', async (params, api) => {
  return sendAsync(ST.getExportFn(params), api)
})
// 活跃机构-导出
export const getLiveTenantsExport = createAsyncThunk<
  void,
  void,
  RootThunkApi
  >('stand/getLiveTenantsExport', async (params, api) => {
  return sendAsync(ST.getLiveTenantsExportFn(), api)
})
// 订单管理-修改订单
export const updateOrder = createAsyncThunk<
  void,
  ST.updateOrderFnParams,
  RootThunkApi
>('ProvinceList/updateOrder', async (params, api) => {
  return sendAsync(ST.updateOrderFn(params), api)
})

// 订单管理-新增订单
export const getAddOrder = createAsyncThunk<
  void,
  ST.getAddOrderFnParams,
  RootThunkApi
>('ProvinceList/getAddOrder', async (params, api) => {
  return sendAsync(ST.getAddOrderFn(params), api)
})


// 获取行政编码
export const getInsuranceCodeAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi
>('ProvinceList/getInsuranceCodeAsync', async (params, api) => {
  return sendAsync(ST.getInsuranceCode(params), api)
})
// 获取机构管理-标签
export const getTenantLabelList = createAsyncThunk<
  any,
  getTenantLabelListFnParams,
  RootThunkApi
>('ProvinceList/getTenantLabelList', async (params, api) => {
  return sendAsync(ST.getTenantLabelListFn(params), api)
})
// 获取标签管理-列表
export const getLabelList = createAsyncThunk<
  any,
  getLabelListFnParams,
  RootThunkApi
>('ProvinceList/getLabelList', async (params, api) => {
  return sendAsync(ST.getLabelListFn(params), api)
})
// 获取标签管理-新增or 编辑
export const getLabelAdd = createAsyncThunk<
  any,
  getLabelAddFnParams,
  RootThunkApi
>('ProvinceList/getLabelAdd', async (params, api) => {
  return sendAsync(ST.getLabelAddFn(params), api)
})



export const { setReplaceOpentype } = tenantSlice.actions

export const selectTenantPage = (state: RootState): Page<Tenant> =>
  state.tenant.page

export const selectReplaceOpentype = (state: RootState) =>
  state.tenant.replaceOpentype

export default tenantSlice.reducer
